<template>
  <div class="modal-body--layers">
    <b-checkbox>
      Select All
    </b-checkbox>
    <FigmaFolderLayer
      v-for="folder in tree"
      :key="folder.data.name"
      :node="folder"
    />
  </div>
</template>

<script>
import FigmaFolderLayer from "@frontend/components/modules/figma-layers/layers/FigmaFolderLayer.vue";

export default {
  name: "FigmaLayersTree",
  components: {FigmaFolderLayer},
  props: {
    tree: {
      type: Array,
      default: () => []
    },
  },
}
</script>
